import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import { IUser } from "../interfaces/UserInterface";
import { ICommonDomain } from "../interfaces/ICommonDomain";
import { IUserRegister } from "../interfaces/IUserRegister";

enum UserServiceEnum {
  postCreateUSer = "?recaptcha=",
  getUserAlreadyResetPassword = "/user-already-reset-password",
  getMigrationPasswordChange = "/migration-password-change",
  setUserAlreadyResetPassword = "/set-user-already-reset-password"
}

export default class UserService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/user");
  }

  public postCreate = async (token, data: IUserRegister): Promise<IUser> => await this.POST(UserServiceEnum.postCreateUSer + token, data);
  public getUserAlreadyResetPassword = async (login: string): Promise<boolean> => await this.GET(`${UserServiceEnum.getUserAlreadyResetPassword}?login=${encodeURIComponent(login)}`);
  public setUserAlreadyResetPassword = async (login: string): Promise<boolean> => await this.GET(`${UserServiceEnum.setUserAlreadyResetPassword}?login=${encodeURIComponent(login)}`);
  public getMigrationPasswordChange = async (): Promise<ICommonDomain> => await this.GET(UserServiceEnum.getMigrationPasswordChange);

}



// WEBPACK FOOTER //
// ./src/services/api/UserService.ts